import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import PropTypes from "prop-types";

import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../Components/adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import ToolTip from "../ToolTip";

import {BUTTON_COLORS, BUTTON_TYPES} from "./constants";

const ImageButton = ({
  src,
  className = "",
  width,
  height,
  size,
  alt,
  type = BUTTON_TYPES.BUTTON,
  children,
  tooltipMessage = "",
  bottomTooltip = false,
  onClick = () => {},
  disabled = false,
  color,
  noFunctional,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
  ...props
}) => {
  const {t} = useTranslation();

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  const tooltipTitle = typeof tooltipMessage === "string" ? t(tooltipMessage) : tooltipMessage;

  return (
    <ToolTip
      title={
        noFunctional
          ? t("No functional")
          : isDisabledByRoutePermission
          ? "Your position has no permission for this action"
          : tooltipTitle
      }
      bottom={bottomTooltip}
      className={clsx("img_btn", className)}
      {...props}
    >
      <button className="img_btn" type={type} onClick={onClick} disabled={disabled || isDisabledByRoutePermission}>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", width: `${width || size}em`}}>
          {children}
          {src !== null && (
            <img
              alt={alt}
              src={src}
              draggable="false"
              className={`${props.disabled || isDisabledByRoutePermission ? "img_disabled" : ""} ${
                noFunctional ? "btnNoFuntional" : ""
              }`}
              style={{
                width: `${width || size}em`,
                height: `${height || size}em`,
                color,
                fill: color,
              }}
            />
          )}
        </div>
      </button>
    </ToolTip>
  );
};

ImageButton.propTypes = {
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  alt: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.values(BUTTON_COLORS)),
  type: PropTypes.oneOf(Object.values(BUTTON_TYPES)),
  onClick: PropTypes.func,
  props: PropTypes.array,
};

export default ImageButton;
